/* eslint-disable */
import { isValidJsonResponse, sanitizeName } from './utils';
import { getCurrentState } from '../store/store-utils';

const ajax = (req) => {
  const headers = new Headers();

  let initData = {};
  if (req.contentType) headers.append('Content-Type', req.contentType);

  if (req.method !== 'GET') {
    const csrfToken = getCurrentState().initialData.csrfToken;
    const csrfHeader = getCurrentState().initialData.csrfHeader;
    if (csrfToken && csrfHeader) headers.append(csrfHeader, csrfToken);

    initData = {
      method: req.method,
      headers
    };
    if (req.contentType === 'multipart/form-data') {
      initData.body = req.body;
    } else {
      initData.body = JSON.stringify(req.body);
    }
  } else {
    initData = {
      method: req.method,
      headers
    };
  }

  const fetchData = async () => {
    try {
      const response = await fetch(new Request(req.url, initData));
      if (!response) return;
      const validJsonResponse = isValidJsonResponse(response);
      if (!validJsonResponse) return;
      const fetchJSON = await response.json();
      if (fetchJSON?.msg) {
        fetchJSON.msg = sanitizeName(fetchJSON.msg);
      }
      if (!fetchJSON.session) {
        if (
          response.status === 403 &&
          fetchJSON.errorCode &&
          fetchJSON.errorCode === 'CSRF_TOKEN_INVALID'
        ) {
          fetchJSON.msg =
            'Unauthorized request, the page will reload in few seconds.';
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          setTimeout(() => {
            window.location.href = '/login';
          }, 3000);
        }
      } else if (
        fetchJSON.session &&
        fetchJSON.data &&
        fetchJSON.data.state === 'session-not-shared'
      ) {
        setTimeout(() => {
          window.location.href = '/logout';
        }, 3000);
      } else if (
        !fetchJSON.status &&
        fetchJSON.data &&
        fetchJSON.data.state === 'accessToken-expired'
      ) {
        setTimeout(() => {
          window.location.href = '/login';
        }, 3000);
      } else if (
        !fetchJSON.status &&
        fetchJSON.data &&
        fetchJSON.data.state === 'public-without-session'
      ) {
        setTimeout(() => {
          window.location.href = '/signup';
        }, 3000);
      }
      return fetchJSON;
    } catch (e) {
      console.error(e);
      return {};
    }
  };

  return fetchData();
};

export { ajax };
